import { useEffect, useState, useCallback } from "react";
import { debounce } from 'lodash';
import dayjs from "dayjs";

export const useChartSetup = (dataSeries) => {
    const [lastHoveredTimestamp, setLastHoveredTimestamp] = useState(null);
    const [lastHoveredPoint, setLastHoveredPoint] = useState(null);
    const [selectedRange, setSelectedRange] = useState({ start: null, end: null });
    const [slidingRange, setSlidingRange] = useState({ start: null, end: null });

    // Create a debounced version of the customSnapshotCallback
    // const debouncedCallback = useCallback(
    //     debounce((point, timestamp) => {
    //         if (customSnapshotCallback) {
    //             try {
    //                 customSnapshotCallback(point, dayjs(timestamp).format('YYYY-MM-DD'));
    //             } catch (e) {
    //                 console.error(e);
    //             }
    //         }
    //     }, 150), // 300ms debounce delay, adjust as needed
    //     [customSnapshotCallback]
    // );
    //
    // useEffect(() => {
    //     if (lastHoveredPoint) {
    //         debouncedCallback(lastHoveredPoint, lastHoveredTimestamp);
    //     }
    // }, [lastHoveredPoint, debouncedCallback]);

    return {
        lastHoveredTimestamp, setLastHoveredTimestamp,
        lastHoveredPoint, setLastHoveredPoint,
        selectedRange, setSelectedRange,
        slidingRange, setSlidingRange
    };
};
